<div
    class="carousel-container"
    *ngIf="item?.layoutType === '1-col-carousel-banner-v3'"
    [ngClass.gt-xs]="'carousel-container__desktop'"
    [ngClass.xs]="'carousel-container__mobile'"
    [ngStyle]="sharedLayoutsService.getStyles(item?.layoutContent?.padding)"
>
    <swiper
        [slidesPerView]="1"
        [spaceBetween]="20"
        [loop]="true"
        [autoplay]="{ delay: 5000, disableOnInteraction: false }"
        [pagination]="{ type: 'bullets', clickable: true }"
        [allowTouchMove]="true"
        (slideChange)="onSlideChange($event)"
    >
        <ng-container *ngFor="let carouselImage of item?.layoutContent?.feed">
            <ng-template swiperSlide>
                <div class="slide-wrapper" ngClass.xs="slide-wrapper-mobile">
                    <!-- Image -->
                    <a
                        *ngIf="carouselImage?.banner?.image"
                        [routerLink]="[
                            carouselImage?.banner?.link | pageIdFromLink
                        ]"
                        [queryParams]="
                            carouselImage?.banner?.link | queryParamFromLink
                        "
                        [attr.aria-label]="
                            carouselImage?.title?.text || 'banner-link'
                        "
                        [style]="{
                            pointerEvents:
                                carouselImage?.banner?.link &&
                                carouselImage?.banner?.link !== ''
                                    ? 'auto'
                                    : 'none'
                        }"
                    >
                        <img
                            [src]="carouselImage?.banner?.image"
                            [alt]="carouselImage?.title?.text || 'banner'"
                            [ngClass]="{
                                'image-banner-shimmer': showShimmer
                            }"
                            appImageCDN
                            class="responsive-image"
                        />
                    </a>

                    <!-- Bottom Content -->
                    <div
                        class="left-bottom-content"
                        ngClass.xs="left-bottom-content__mobile"
                        *ngIf="
                            carouselImage?.title?.text ||
                            carouselImage?.subtitle?.text ||
                            carouselImage?.button?.title?.text
                        "
                    >
                        <h1
                            *ngIf="carouselImage?.title?.text"
                            class="title"
                            ngClass.xs="title__mobile"
                            [style]="{ color: carouselImage?.title?.color }"
                            [ngStyle.gt-xs]="{
                                margin: carouselImage?.subtitle?.text
                                    ? '0 0 2px 0'
                                    : '0 0 24px 0'
                            }"
                            [ngStyle.xs]="{
                                margin: carouselImage?.subtitle?.text
                                    ? '0 0 2px 0'
                                    : '0 0 16px 0'
                            }"
                            >{{ carouselImage?.title?.text }}</h1
                        >
                        <p
                            *ngIf="carouselImage?.subtitle?.text"
                            class="subtitle"
                            ngClass.xs="subtitle__mobile"
                            [innerHTML]="
                                carouselImage?.subtitle?.text | lineBreak
                            "
                            [style]="{ color: carouselImage?.subtitle?.color }"
                            [ngStyle.gt-xs]="{
                                margin: !!carouselImage?.button?.title?.text
                                    ? '0 0 24px 0'
                                    : '0'
                            }"
                            [ngStyle.xs]="{
                                margin: !!carouselImage?.button?.title?.text
                                    ? '0 0 16px 0'
                                    : '0'
                            }"
                            >{{ carouselImage?.subtitle?.text }}</p
                        >
                        <a
                            *ngIf="carouselImage?.button?.title?.text"
                            [routerLink]="[
                                carouselImage?.button?.link | pageIdFromLink
                            ]"
                            [queryParams]="
                                carouselImage?.button?.link | queryParamFromLink
                            "
                            style="
                                text-decoration: none;
                                display: flex;
                                width: fit-content;
                            "
                            [attr.aria-label]="
                                carouselImage?.button?.title?.text ||
                                'button-link'
                            "
                        >
                            <button
                                *ngIf="carouselImage?.button?.title?.text"
                                class="button-with-round-corners"
                                [style]="{
                                    color: carouselImage?.button?.title?.color,
                                    background:
                                        carouselImage?.button?.background?.color
                                }"
                                >{{
                                    carouselImage?.button?.title?.text
                                }}</button
                            >
                        </a>
                    </div>
                </div>
            </ng-template>
        </ng-container>
    </swiper>
</div>
